import React from "react";
import { Link } from "react-router-dom";

// Simple Breadcrumb component
// Expects a `paths` prop, which is an array of objects:
// [{ name: 'Home', path: '/' }, { name: 'Category', path: '/category' }, { name: 'Current Page' }]

const breadcrumbItemStyle = {
  display: "inline",
  marginRight: "5px",
};

const breadcrumbLinkStyle = {
  color: "#007bff",
  textDecoration: "none",
};

const breadcrumbCurrentStyle = {
  color: "#6c757d",
};

const separatorStyle = {
  margin: "0 5px",
  color: "#6c757d",
};

export default function Breadcrumbs({ paths }) {
  if (!paths || paths.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="breadcrumb"
      style={{ marginBottom: "20px", fontSize: "0.9em" }}
    >
      <ol style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {paths.map((pathItem, index) => (
          <li key={index} style={breadcrumbItemStyle}>
            {pathItem.path ? (
              <Link to={pathItem.path} style={breadcrumbLinkStyle}>
                {pathItem.name}
              </Link>
            ) : (
              <span style={breadcrumbCurrentStyle}>{pathItem.name}</span>
            )}
            {index < paths.length - 1 && (
              <span style={separatorStyle}>&gt;</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
